import React, { ReactElement, memo, useCallback } from 'react'
import { Link } from 'gatsby'
import Slider from 'react-slick'
import { PropertyCardTypes } from '../PropertyCard/PropertyCard.types'
import './SliderSection.scss'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import { ArticleCardTypes } from '../ArticleCard/ArticleCard'

type SliderSectionPropTypes = {
  title?: string
  titleImage?: string
  subTitle?: string
  description: string
  link: string
  className?: string
  slideList: (PropertyCardTypes | ArticleCardTypes)[]
  listMapper(item: PropertyCardTypes | ArticleCardTypes): ReactElement
}

const SliderSection = ({
  title,
  titleImage,
  subTitle,
  description,
  link,
  slideList,
  className,
  listMapper,
}: SliderSectionPropTypes): ReactElement => {
  const displayTitle = useCallback((): ReactElement => {
    if (!title) return <></>

    const titleArray = title.split(' ')
    const lastString = titleArray.pop()

    return (
      <h3>
        {titleArray.join(' ')} <span>{lastString}</span>
      </h3>
    )
  }, [title])

  return (
    <div className={`slider-section${className ? ` ${className}` : ''}`}>
      <div className="slider-header">
        {!!subTitle && <h4>{subTitle}</h4>}
        {!!title && displayTitle()}
        {!!titleImage && <img src={titleImage} alt="close icon" />}
        <p dangerouslySetInnerHTML={{ __html: description ?? '' }} />
      </div>
      <Slider
        infinite={false}
        variableWidth
        // centerMode
        slidesToShow={3}
        className="slider"
        swipe={true}
        responsive={[
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              swipe: true,
              swipeToSlide: true,
              centerMode: false,
              // infinite: true,
            },
          },
        ]}
      >
        {slideList.map(listMapper)}
      </Slider>
      <div className="link-container">
        <Link to={`/${link}/`}> Read more </Link>
      </div>
    </div>
  )
}

export default memo(SliderSection)
